export type SortItem = {
	name: string;
	sortProperty: string;
};

export const sortNames: SortItem[] = [
	{ name: 'популярности', sortProperty: 'rating' },
	{ name: 'цене', sortProperty: 'price' },
	{ name: 'алфавиту', sortProperty: 'title' },
];
